import { Component, ViewEncapsulation } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { ClipboardService } from '../../../service/clipboard.service';

@Component({
  selector: 'ngx-clipboard-column',
  template: `
    <div class="cell-content">
      <span>{{ params.value }}</span>
      <button class="clipboard" nbButton ghost size="tiny" (click)="copyToClipboard($event)"><nb-icon icon="clipboard-outline"></nb-icon></button>
    </div>
  `,
  styles: [
    `
      .cell-content {
        display: flex;
        align-items: center;
      }
      .nb-theme-dark .clipboard:focus {
        position: absolute;
        outline: none !important;
        box-shadow: none !important;
      }
      .clipboard {
        opacity: 30%;
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        margin-right: 2px;
      }
      .clipboard:hover {
        opacity: 100%;
        background-color: #151A30 !important;
      }
    `
  ],
  encapsulation: ViewEncapsulation.None,
})
export class ClipboardComponent implements ICellRendererAngularComp {
  public params: ICellRendererParams;
  public status: string = 'basic';

  constructor(
    private clipboardService: ClipboardService,
  ) {}

  refresh(params: ICellRendererParams): boolean {
    this.params = params;
    return true;
  }

  agInit(params: ICellRendererParams): void {
    this.params = params;
  }

  copyToClipboard(event: MouseEvent) {
    event.stopPropagation();
    event.preventDefault();
    this.clipboardService.copy(this.params.value, true);
  }

  ngOnInit() {}
}
